exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-erfasst-user-index-tsx": () => import("./../../../src/pages/erfasst/user/index.tsx" /* webpackChunkName: "component---src-pages-erfasst-user-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-quality-user-index-tsx": () => import("./../../../src/pages/quality/user/index.tsx" /* webpackChunkName: "component---src-pages-quality-user-index-tsx" */)
}

